module.exports = __webpack_public_path__ + "static/Collateral-50743d6aaf06d12a6fd5d0d1353ed9c8.png";